import React, { useId, useState } from "react";
import "./Accordion.css";

export default function Accordion() {
  const [openIndex, setOpenIndex] = useState(0);
  const accordionId = useId();

  const data = [
    {
      title: "Why should students choose EMEI for computer education?",
      text: "EMEI focuses on practical, industry-oriented computer education that prepares students for real-world challenges. From programming and web development to AI, data analytics, and digital skills, students build the knowledge and confidence to succeed in today's technology-driven world. Our goal is to empower every student with skills for a brighter future."
    },
    {
      title: "What makes EMEI different from other computer institutes?",
      text: "EMEI stands out through practical learning, skill development, and career-oriented education. Students apply what they learn through hands-on practice and projects, with training in modern technologies such as AI, machine learning, web development, and digital marketing. This helps them stay aware of industry trends and grow into confident, skilled professionals."
    },
    {
      title: "Why is EMEI the right place to start your IT career?",
      text: "EMEI helps students build a strong foundation in technology while developing the practical skills employers value. Whether you are a beginner, a college student, or looking to upgrade your skills, you can learn, practise, and explore different IT career paths. With the right guidance, dedication, and technical knowledge, every student can take a confident step towards a successful career."
    },
    {
      title: "What career opportunities can students explore after learning at EMEI?",
      text: "Depending on their skills, qualifications, and specialisation, students can explore careers such as web developer, software developer, Python programmer, AI and machine learning professional, data analyst, UI/UX designer, graphic designer, video editor, cybersecurity professional, digital marketer, or mobile app developer. They can also consider freelancing, internships, and entrepreneurship. EMEI helps students discover their interests, develop relevant skills, and prepare for opportunities in the growing digital and IT industries."
    }
  ];

  return (
    <section className="home-accordion" aria-label="Frequently asked questions">
      {data.map((item, index) => {
        const isOpen = openIndex === index;
        const triggerId = `${accordionId}-trigger-${index}`;
        const panelId = `${accordionId}-panel-${index}`;

        return (
          <div className={`home-accordion__item${isOpen ? " is-open" : ""}`} key={index}>
            <h3 className="home-accordion__heading">
              <button
                type="button"
                id={triggerId}
                className="home-accordion__trigger"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpenIndex((current) => current === index ? null : index)}
              >
                <span>{item.title}</span>
                <span className="home-accordion__icon" aria-hidden="true" />
              </button>
            </h3>
            <div
              id={panelId}
              className="home-accordion__panel"
              role="region"
              aria-labelledby={triggerId}
              aria-hidden={!isOpen}
            >
              <div className="home-accordion__inner">
                <p className="home-accordion__description">{item.text}</p>
              </div>
            </div>
          </div>
        );
      })}
    </section>
  );
}
